<template>
  <div class="TimeCounterContainer">
    {{value}}
  </div>
</template>

<script>

//import component from '@assets/components/component.vue'
import { eventBus } from '@/utils'

export default {
  name: 'TimeCounterContainer',
  components: {
    //component
  },
  props: {
    elref: {default: null},
  },
  data: function () {
    return {
      value: 0
    }
  },
  computed: {
  },
  methods: {
    setCallbacks: function () {
    },
  },
  created: function () {
  },
  mounted: function () {
    setInterval(function(){
      this.value++;
    }.bind(this), 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.TimeCounterContainer{
  background: rgb(235,189,0);
  border: 5px solid black;
  color: black;
  font-size: 3em;
  font-family: 'Impact';
  height: 2.5em;
  width: 2.5em;
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

</style>
